<template>
  <loader
    v-show="commonStore.loader"
    name="dots"
    object="#d2b88f"
    size="5"
    speed="2"
    bg="#343a40"
    objectbg="#999793"
    opacity="20"
    :disableScrolling="false"
  ></loader>
  <header-box-5
    v-if="enabledStore.portalTypeBooks !== null"
    :bookPortal="enabledStore.portalTypeBooks"
  ></header-box-5>
  <main :class="pageClass">
    <div class="container">
      <router-view @updatePageClass="handlePageClass"></router-view>
    </div>
  </main>
  <footer-box-6></footer-box-6>
  <modal-access
        v-if="!isAuth"
        title="Like our content?"
        text="Membership now and unlock unlimited access to all our content and exclusive features."
    ></modal-access>
</template>

<script>
  import { useAuthStore, useCommonStore, useEnabledStore } from '@/stores';
  import { RouterView } from 'vue-router';
  import HeaderBox5 from './components/layouts/header/HeaderBox5.vue';
  import FooterBox6 from './components/layouts/footer/FooterBox6.vue';
  import ModalAccess from "@/components/modals/ModalAccess.vue";

  export default {
    components: {
      RouterView,
      HeaderBox5,
      FooterBox6,
      ModalAccess,
    },
    data() {
      return {
        pageClass: '',
        commonStore: useCommonStore(),
        authStore: useAuthStore(),
        enabledStore: useEnabledStore(),
      };
    },
    watch: {
      $route(to, from) {
        this.pageClass = '';
      },
    },
    methods: {
      handlePageClass(newClass) {
        this.pageClass = newClass;
      },
      async checkPortalType() {
        this.enabledStore.checkPortalType();
      },

    },
    created() {
      this.checkPortalType();
    },

    computed: {
      isAuth() {
        return this.authStore.isAuth;
      },
      isPortalTypeBooks() {
        return this.enabledStore.isPortalTypeBooks;
      },
    },
  };
</script>
